import { Image, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowOpremaEvdListaEvidencijaHeader: React.FC<{
  datum: string;
  imePrezime: string;
  potpis: string;
  tip: string;
  izvrsioc: string;
  potpisIzvrsioca: string;
  opis: string;
  tackaEvidencije: string;
}> = ({
  imePrezime,
  potpis,
  tip,
  izvrsioc,
  potpisIzvrsioca,
  opis,
  datum,
  tackaEvidencije,
}) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text>{tackaEvidencije}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{imePrezime}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{potpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{tip}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{izvrsioc}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{potpisIzvrsioca}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{opis}</Text>
    </View>
  </View>
);

export const TableRowOpremaEvdListaEvidencija: React.FC<{
  datum?: string;
  fullname: string;
  potpis: string;
  tip: string;
  izvrsioc: string;
  potpisIzvrsioca: string;
  opis: string;
  tackaPrimjene: string;
}> = ({
  datum,
  fullname,
  potpis,
  tip,
  izvrsioc,
  potpisIzvrsioca,
  opis,
  tackaPrimjene,
}) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{tackaPrimjene}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpis && (
        <Image style={[styles.tableCell, styles.signatureImage]} src={potpis} />
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{tip}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{izvrsioc}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpis && (
        <Image
          style={[styles.tableCell, styles.signatureImage]}
          src={potpisIzvrsioca}
        />
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{opis}</Text>
    </View>
  </View>
);
